<template>
  <Forbidden />
</template>

<script>
import Forbidden from '@Ravnur-Inc/shared/components/forbidden.vue';

export default {
   name: 'ForbiddenComponent',
   components: {
     Forbidden,
   }
};
</script>